
module.exports = {
    myHost: {
       'host':'https://api-blast.bitflex.xyz',
    }
};
